import { DEVICE_SIZE } from '@core/models/deviceSize.model';
import { StatusRequest } from '@core/models/request-status.model';

export enum CX_COMPONENT {
  BANNER_CAROUSEL = 'BANNER_CAROUSEL',
  BANNER_GRID = 'BANNER_GRID',
  PRODUCT_CAROUSEL = 'PRODUCT_CAROUSEL',
  GRID_CATEGORIES = 'GRID_CATEGORIES',
  AUXILIARY_LINKS = 'AUXILIARY_LINKS',
  LOGO = 'LOGO',
  MAIN_NAVIGATION_BAR = 'MAIN_NAVIGATION_BAR',
  PROFILE_LINKS = 'PROFILE_LINKS',
  FOOTER_NAVIGATION_BAR = 'FOOTER_NAVIGATION_BAR',
  TERM_LINK = 'TERM_LINK',
  PARAGRAPH = 'PARAGRAPH',
}

export type DeviceType = 'DESKTOP' | 'MOBILE' | 'BOTH';

export interface Link {
  id?: string;
  uid?: string;
  url?: string;
  linkName?: string;
  isExternal?: boolean;
  styleClass?: string;
  routerLink?: string[];
  media?: Media;
  deviceType?: DeviceType;
  children?: Link[];
}

export interface Media {
  src: string;
  altText?: string;
}

export type LogoContainer = {
  linkName: string;
  logo: MediaContainer;
  url: string;
};

export type MediaContainer = {
  [key in DEVICE_SIZE]: Media;
};

export interface ResponsiveCategoryGrid {
  id?: string;
  items: {
    link: Link;
    media: MediaContainer;
  }[];
}

export interface ResponsiveProductCarousel {
  uid: string;
  products: string[];
}

export interface ResponsiveBannerCarousel {
  id?: string;
  banners?: MediaContainer[];
  link?: Link;
  autoplayInterval?: number;
}

// Interfaces para dados do CMS Banner
export interface CmsBannerItem {
  medias?: MediaContainer;
}

export interface CmsBannerResponse {
  uid?: string;
  id?: string;
  banners?: CmsBannerItem[];
  link?: string;
  sleep?: number;
}

export interface CxComponent<T = unknown> {
  type: CX_COMPONENT;
  data: T;
}

export interface Section {
  id: string;
  components: CxComponent[];
}

export interface Page extends StatusRequest {
  id?: string;
  title?: string;
  components: CxComponent[];
}

export interface CmsComponent<T = unknown> {
  uid: string;
  model: string;
  type: string;
  data: T;
}

export interface CmsSection {
  id: string;
  name: string;
  components: CmsComponent[];
}

export interface CmsPage {
  componentType: string;
  id: string;
  title: string;
  sections: CmsSection[];
}
